import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { isEmpty, toArray } from 'lodash'
import { pluralize } from 'humanize-plus'
import { Button, Table, Modal, Icon } from '@driftt/tide-core-legacy'

import { fetchOrgTeams, patchOrgTeam } from 'app/modules/teams/actions'
import {
  patchTeamSucceeded,
  patchTeamFailed,
  makeTeamSelector,
  teamOwner,
  teamMembers,
  onlineTeamMembers,
  offlineTeamMembers,
} from 'app/modules/teams/selectors'

import app from 'containers/app'
import RowFormatter from './RowFormatter'
import AddTeamMembers from 'components/settings/team/AddTeamMembers'
import { patchOperations } from 'utils/PatchHelper'

import './style.styl'

const UserColumns = [
  {
    label: 'User',
    value: 'user',
  },
]

class EditTeamModal extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      teamMembers: toArray(props.teamMembers),
      showAddMembers: false,
    }
  }

  componentDidUpdate(prevProps) {
    const { patchTeamFailed, patchTeamSucceeded, actions, onCancelTeamEdit } = this.props

    if (prevProps.patchTeamFailed !== patchTeamFailed) {
      onCancelTeamEdit()
      this.sendPatchTeamFailedNotification()
    }

    if (prevProps.patchTeamSucceeded !== patchTeamSucceeded) {
      onCancelTeamEdit()
      actions.fetchOrgTeams()
      this.sendPatchTeamSucceededNotification()
    }
  }

  onCancelClick = () => {
    this.props.onCancelTeamEdit()
  }

  hideAddMembersModal = () => {
    this.setState({ showAddMembers: false })
  }

  showAddMembers = () => {
    this.setState({ showAddMembers: true })
  }

  updateTeamMembers = teamMembers => {
    this.setState({ teamMembers })
    this.hideAddMembersModal()
  }

  removeTeamMember = memberToRemove => {
    const membersClone = [...this.state.teamMembers]
    this.setState({ teamMembers: membersClone.filter(member => member.id !== memberToRemove.id) })
  }

  saveTeam = () => {
    const { actions, team } = this.props
    const { teamMembers } = this.state

    const patchedProperties = patchOperations({
      members: teamMembers.map(member => member.id),
    })

    actions.patchOrgTeam({ teamId: team.id, properties: patchedProperties })
  }

  sendPatchTeamFailedNotification = () => {
    app.actions.NotificationActions.pushNotification({
      variant: 'red',
      content: 'We failed to save your team. Please try again or contact support for help.',
    })
  }

  sendPatchTeamSucceededNotification = () => {
    const { team } = this.props

    app.actions.NotificationActions.pushNotification({
      content: `Your team "${team.name}" has been successfully updated!`,
    })
  }

  renderCreateTeamContent = () => {
    const { team, onlineMemberIds, offlineMemberIds, teamOwner } = this.props
    const { teamMembers } = this.state

    const selectedOnlineMembers = teamMembers.filter(user => onlineMemberIds.includes(user.id))
    const selectedOfflineMembers = teamMembers.filter(user => offlineMemberIds.includes(user.id))
    return (
      <div className="team-modal-content-container">
        <h4 className="team-modal-header">Manage team</h4>
        <div className="team-modal-content">
          <div className="team-name-content">
            <div>
              <p className="team-edit-name-description">
                <strong>{team.name}</strong>, created by {teamOwner.name}
              </p>
            </div>
            <div className="team-name-modal-edit-members">
              <div className="team-name-modal-member-description">
                {teamMembers.length} {pluralize(teamMembers.length, 'Member')}
                <span className="team-name-modal-member-count">
                  {` ${selectedOnlineMembers.length} Available / ${selectedOfflineMembers.length} Away `}
                </span>
              </div>
              <Button
                type="utility"
                className="add-members-button"
                iconAlignment="right"
                onClick={this.showAddMembers}
              >
                {teamMembers.length ? 'Edit teammates' : 'Add teammates'}
              </Button>
            </div>
            {!isEmpty(teamMembers) && (
              <Table
                className="team-edit-members-table"
                columns={UserColumns}
                data={RowFormatter({ members: teamMembers, onMemberDelete: this.removeTeamMember })}
              />
            )}
          </div>
        </div>
        <div className="team-name-modal-button-container">
          <Button disabled={isEmpty(teamMembers)} onClick={this.saveTeam}>
            Save team
          </Button>
          <Button type="tertiary" onClick={this.onCancelClick}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  render() {
    const { onCancelTeamEdit } = this.props
    const { teamMembers, showAddMembers } = this.state

    return (
      <Modal
        className="add-members-modal"
        open={true}
        onClose={this.onCancelClick}
      >
        {!showAddMembers && this.renderCreateTeamContent()}
        {showAddMembers && (
          <AddTeamMembers
            onCancel={this.hideAddMembersModal}
            teamMembers={teamMembers}
            onSave={this.updateTeamMembers}
            onBackLinkClick={this.hideAddMembersModal}
          />
        )}
      </Modal>
    )
  }
}

const mapStateToProps = (state, props) => {
  const onlineTeam = onlineTeamMembers(props.teamId)(state)
  const offlineTeam = offlineTeamMembers(props.teamId)(state)
  return {
    team: makeTeamSelector()(state, { teamId: props.teamId }),
    teamOwner: teamOwner(props.teamId)(state),
    teamMembers: teamMembers(state, { teamId: props.teamId }),
    onlineMemberIds: onlineTeam.map(user => user.id),
    offlineMemberIds: offlineTeam.map(user => user.id),
    patchTeamFailed: patchTeamFailed(state),
    patchTeamSucceeded: patchTeamSucceeded(state),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchOrgTeams,
      patchOrgTeam,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(EditTeamModal)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/EditTeamModal/index.js